enum ReportReason {
  BadContent = 'BAD_CONTENT',
  Duplicate = 'DUPLICATE',
  WrongLanguage = 'WRONG_LANGUAGE',
  WrongCategory = 'WRONG_CATEGORY',
  Other = 'OTHER',
}

export default ReportReason
